import analytics from '../analytics';
import { PURCHASE_SECTION, SUBSCRIBE_EMAIL_CONTAINER } from '../classnames/home';
import { SIDEBAR_POPUP_CONTAINER } from '../classnames/sidebar-popup';
import { REVIEWS_SECTION_ID } from '../classnames/reviews';
import { CITATIONS_CONTAINER } from '../classnames/scientific-citations';
import { UGC_SELECTOR } from '../classnames/ugc-selector';
import SessionStorage from '../utils/session-storage';
import { SELECTORS as BASE_EMAIL_SELECTORS } from '../shared/form/base-email';

import { GEOLOCATION_DATA_KEY } from '../utils/session-storage-keys';
import { SELECTORS as ANNOUNCEMENT_BAR_SELECTORS } from '../announcement-bar/constants';
import { SELECTORS as REFERRAL_BAR_SELECTORS } from '../referral-bar/constants';
import { SELECTORS as COUNTDOWN_TIMER_SELECTORS } from '../countdown-timer/constants';
import { SELECTORS as PRODUCT_CARD_SELECTORS } from '../product-card-v3/constants';
import { SELECTORS as CLIPBOARD_COPY_SELECTORS } from '../shared/сlipboard-сopy/constants';
import { SELECTORS as TAB_SELECTORS } from '../shared/tab/constants';
import { SELECTORS as ABOVE_THE_FOLD_SELECTORS } from '../above-the-fold/constants';
import { SELECTORS as IMAGES_VISIBILITY_SELECTORS } from '../shared/images-visibility/constants';
import { SELECTORS as ANCHOR_NAVIGATION_SELECTORS } from '../navigation/anchor/constants';
import { ATTN_DATA_ATTR } from '../vendors/constants';
import { SELECTORS as ZAPIER_FORM_SELECTORS } from '../zapier-form-handler/constants';
import { SELECTORS as FREE_GIFT_OPT_IN_SELECTORS } from '../free-gift-opt-in/constants';
import { SELECTORS as UPGRADE_OFFER_SELECTORS } from '../upgrade-offer/constants';
import { SELECTORS as WINBACK_OFFER_SELECTORS } from '../winback-offer/constants';
import { STOREMAPPER_CONTAINER } from '../store-locator/constants';
import { SNOW_CANVAS_SELECTOR } from '../components/snow-canvas/constants';
import { updateFixedNavHeight } from '../utils/update-fixed-nav-height';

export default class HandlersByClassName {
  bodyClassList = document.body.classList;
  isDomesticCustomer = SessionStorage.get(GEOLOCATION_DATA_KEY)?.isDomestic;

  initializeHandlers() {
    updateFixedNavHeight();

    if (document.querySelector(`.${ANNOUNCEMENT_BAR_SELECTORS.CONTAINER}`)) {
      import('../announcement-bar').then(({ AnnouncementBar }) => {
        new AnnouncementBar().initialize();
      });
    }

    if (document.querySelector(`.${REFERRAL_BAR_SELECTORS.CONTAINER}`)) {
      import('../referral-bar').then(({ ReferralBar }) => {
        new ReferralBar().initialize();
      });
    }

    if (document.querySelectorAll(`.${ANCHOR_NAVIGATION_SELECTORS.CONTAINER}`).length > 0) {
      import('../navigation/anchor').then(({ AnchorNav }) => {
        document.querySelectorAll(`.${ANCHOR_NAVIGATION_SELECTORS.CONTAINER}`).forEach((container) => {
          new AnchorNav(container).initialize();
        });
      });
    }

    if (document.getElementsByClassName('swiper').length > 0) {
      import('../swiper').then(({ default: Swiper }) => {
        new Swiper().initialize();
      });
    }

    if (document.querySelectorAll(`.${BASE_EMAIL_SELECTORS.FORM}`).length > 0) {
      import('../shared/form/base-email').then(({ BaseEmail }) => {
        const forms = document.querySelectorAll(`.${BASE_EMAIL_SELECTORS.FORM}`);

        forms.forEach((form) => new BaseEmail(form).initialize());
      });
    }

    if (document.querySelectorAll(`.${CLIPBOARD_COPY_SELECTORS.CONTAINER}`)) {
      import('../shared/сlipboard-сopy').then(({ ClipboardCopy }) => {
        new ClipboardCopy().initialize();
      });
    }

    if (document.querySelector(`.${ABOVE_THE_FOLD_SELECTORS.PRODUCT_CARD}`)) {
      import('../above-the-fold').then(({ AboveTheFold }) => {
        const container = document.querySelector(`.${ABOVE_THE_FOLD_SELECTORS.PRODUCT_CARD}`);

        new AboveTheFold(container).initializeEventListeners();
      });
    }

    if (document.getElementById(REVIEWS_SECTION_ID)) {
      import('../reviews/section-renderer').then(({ ReviewsRenderer }) => {
        new ReviewsRenderer(document.getElementById(REVIEWS_SECTION_ID)).initialize();
      });
    }

    if (this.bodyClassList.contains('product') || this.bodyClassList.contains('reviews')) {
      analytics.productViewed();
    }

    if (this.bodyClassList.contains('blog')) {
      import('../blog/post-list').then(({ default: BlogPostsList }) => {
        new BlogPostsList().initializeEventListeners();
      });
    }

    if (this.bodyClassList.contains('article')) {
      import('../blog/index').then(({ default: Blog }) => {
        new Blog().initialize();
      });

      import('../blog/pinterest-button').then(({ default: PinterestButton }) => {
        new PinterestButton().initialize();
      });
    }

    if (this.bodyClassList.contains('article') || this.bodyClassList.contains('blog')) {
      import('../lib/youtube-player').then(({ default: YouTubePlayer }) => {
        YouTubePlayer.initialize();
      });
    }

    if (document.querySelectorAll(`.${SIDEBAR_POPUP_CONTAINER}`).length > 0) {
      import('../sidebar-popup').then(({ default: SidebarPopup }) => {
        new SidebarPopup().initializeEventListeners();
      });
    }

    if (document.querySelector(`.${CITATIONS_CONTAINER}`)) {
      import('../scientific-citations').then(({ default: ScientificCitations }) => {
        new ScientificCitations().render();
      });
    }

    if (document.querySelector(`.${SUBSCRIBE_EMAIL_CONTAINER}`)) {
      import('../home/email-subscription').then(({ default: HomeEmailSubscription }) => {
        new HomeEmailSubscription().initialize();
      });
    }

    if (document.getElementById(PURCHASE_SECTION)) {
      import('../home/purchase-section').then(({ default: PurchaseSection }) => {
        new PurchaseSection().initializeEventListeners();
      });
    }

    if (this.bodyClassList.contains('index') || this.bodyClassList.contains('home-old')) {
      import('../home/hero-animation').then(({ default: HomeHeroAnimation }) => {
        new HomeHeroAnimation().initialize();
      });
    }

    if (document.querySelector(`.${IMAGES_VISIBILITY_SELECTORS.CONTAINER}`)) {
      import('../shared/images-visibility').then(({ default: ImagesVisibilityHandler }) => {
        document.querySelectorAll(`.${IMAGES_VISIBILITY_SELECTORS.CONTAINER}`).forEach((container) => {
          new ImagesVisibilityHandler(container).initialize();
        });
      });
    }

    if (document.getElementsByClassName(UGC_SELECTOR).length > 0) {
      import('../ugc-selector').then(({ default: UGCSelector }) => {
        new UGCSelector().initialize();
      });
    }

    if (document.querySelectorAll(`.${TAB_SELECTORS.CONTAINER}`).length > 0) {
      import('../shared/tab').then(({ Tab }) => {
        const containers = document.querySelectorAll(`.${TAB_SELECTORS.CONTAINER}`);

        [...containers].forEach((container) => new Tab(container).initializeEventListeners());
      });
    }

    if (document.querySelectorAll(`.${PRODUCT_CARD_SELECTORS.CARD}`).length > 0) {
      import('../product-card-v3').then(({ ProductCardV3 }) => {
        const cards = document.querySelectorAll(`.${PRODUCT_CARD_SELECTORS.CARD}`);

        cards.forEach((card) => new ProductCardV3(card).initialize());
      });
    }

    if (document.querySelector('.js-submit-review')) {
      import('../reviews/form').then(({ default: Form }) => {
        new Form().initializeEventListeners();
      });
    }

    if (document.querySelector('.js-product-review-success-banner')) {
      import('../reviews/success-banner').then(({ default: SuccessBanner }) => {
        new SuccessBanner().initializeEventListeners();
      });
    }

    if (document.querySelector('.js-text-input .input__field')) {
      import('../design-system/input').then(({ default: Input }) => {
        new Input().initializeEventListeners();
      });
    }

    if (document.querySelector('.js-toggle-item-container')) {
      import('../design-system/toggle').then(({ Toggle }) => {
        new Toggle().initializeEventListeners();
      });
    }

    if (document.querySelector(`.${COUNTDOWN_TIMER_SELECTORS.CONTAINER}`)) {
      import('../countdown-timer').then(({ CountdownTimer }) => {
        new CountdownTimer(document.querySelector(`.${COUNTDOWN_TIMER_SELECTORS.CONTAINER}`)).initialize();
      });
    }

    if (document.querySelector(`.${ZAPIER_FORM_SELECTORS.FORM_CONTAINER}`)) {
      import('../zapier-form-handler').then(({ ZapierFormHandler }) => {
        new ZapierFormHandler().initialize();
      });
    }

    if (document.querySelector(`[${ATTN_DATA_ATTR}="true"]`)) {
      import('../vendors/attentive-popup').then(({ AttentivePopup }) => {
        new AttentivePopup().hide();
      });
    }

    if (document.querySelector(`.${FREE_GIFT_OPT_IN_SELECTORS.CONTAINER}`)) {
      import('../free-gift-opt-in').then(({ FreeGiftOptInHandler }) => {
        new FreeGiftOptInHandler().initialize();
      });
    }

    if (document.querySelector(`.${UPGRADE_OFFER_SELECTORS.CONTAINER}`)) {
      import('../upgrade-offer').then(({ UpgradeOfferHandler }) => {
        new UpgradeOfferHandler().initialize();
      });
    }

    if (document.querySelector(`.${WINBACK_OFFER_SELECTORS.CONTAINER}`)) {
      import('../winback-offer').then(({ WinbackOfferHandler }) => {
        new WinbackOfferHandler().initialize();
      });
    }

    if (document.getElementById(STOREMAPPER_CONTAINER)) {
      import('../store-locator').then(({ StoreLocator }) => {
        new StoreLocator().initialize();
      });
    }

    if (document.body.classList.contains('science')) {
      import('../pages/science').then(({ SciencePage }) => {
        new SciencePage().initialize();
      });
    }

    if (document.body.classList.contains('replo-clp')) {
      import('../pages/clp').then(({ ClpPage }) => {
        new ClpPage().initialize();
      });
    }

    if (document.querySelector(`[${SNOW_CANVAS_SELECTOR}]`)) {
      import('../components/snow-canvas').then(({ default: SnowCanvas }) => {
        const containers = document.querySelectorAll(`[${SNOW_CANVAS_SELECTOR}]`);

        containers.forEach((container) => {
          new SnowCanvas(container).initialize();
        });
      });
    }
  }
}
